import * as ko from "knockout";
ko.bindingHandlers.log = {
    init: function (element, valueAccessor) {
        console.log(ko.map.toJS(valueAccessor()));
    }
};